import { defineComponent as o, createBlock as t, openBlock as r, unref as c, mergeProps as m, withCtx as p, createElementVNode as a } from "vue";
import { RevIcon as u } from "@ds/components/Icon";
const f = /* @__PURE__ */ o({
  name: "IconReassuranceLockOutlined",
  __name: "IconReassuranceLockOutlined",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(n) {
    const l = n;
    return (s, e) => (r(), t(c(u), m(l, { "view-box": "0 0 48 48" }), {
      default: p(() => [...e[0] || (e[0] = [
        a("path", { d: "M23.85 28.01c.43.08.93-.59 1.09-1.49.17-.9-.06-1.68-.49-1.77-.43-.09-.92.58-1.09 1.48-.17.9.06 1.7.49 1.78m3.42-1.05c-.04.91.29 1.69.73 1.69.48.02.84-.7.88-1.62.04-.92-.28-1.69-.73-1.7-.45-.01-.84.72-.88 1.63m-7.822.643A.34.34 0 0 0 19.2 27.65h.03A.35.35 0 0 0 19.1 28a7.101 7.101 0 0 0 1.39 2.45 7.795 7.795 0 0 0 1 1 8.37 8.37 0 0 0 3.8 1.73 8.526 8.526 0 0 0 2.76 0A.33.33 0 1 0 28 32.52a9.551 9.551 0 0 1-4.83-1.26 9.445 9.445 0 0 1-1.93-1.52 13.812 13.812 0 0 1-1.58-2 .34.34 0 0 0-.212-.137" }, null, -1),
        a("path", {
          "fill-rule": "evenodd",
          d: "m19.57 12.55-.853 4.59-1.387-.26A4.58 4.58 0 0 0 12 20.53l-2.33 12.3a4.58 4.58 0 0 0 3.66 5.33l17.37 3.25a4.758 4.758 0 0 0 .84.07 4.52 4.52 0 0 0 2.55-.8A4.59 4.59 0 0 0 36 37.75l2.36-12.29a4.58 4.58 0 0 0-3.66-5.33l-1.508-.282.898-4.588a7.39 7.39 0 0 0-14.52-2.71m13.59 2.53-.857 4.602-12.582-2.355.899-4.587a6.38 6.38 0 0 1 12.54 2.34m-13.956 3.171 13.337 2.501a.486.486 0 0 0 .069.018h.026l1.814.34a3.59 3.59 0 0 1 2.29 1.49 3.521 3.521 0 0 1 .56 2.67L35 37.57a3.56 3.56 0 0 1-4.12 2.84l-17.37-3.25A3.56 3.56 0 0 1 10.66 33L13 20.71a3.57 3.57 0 0 1 3.46-2.91 3.68 3.68 0 0 1 .66.06l1.74.326a.506.506 0 0 0 .344.065",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
